// JS file for PublicationList
